import axios from 'axios'
import {AuthModel} from '../models/AuthModel'
import {UserInterface} from '../models/UserModel'
import {Get} from '../../../../setup'

const API_URL = process.env.REACT_APP_API_URL || 'api'
const GET_USER = process.env.REACT_APP_GET_USER || 'get_user'
const FORGOT_PASSWORD = process.env.REACT_APP_FORGOT_PASSWORD || 'mot-passe-oublier'
const RESET_PASSWORD = process.env.REACT_APP_RESET_PASSWORD ||'reinitialiser-mot-passe'

export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/${GET_USER}`
export const LOGIN_URL = `${API_URL}/login`
export const REGISTER_URL = `${API_URL}/auth/register`
export const REQUEST_PASSWORD_URL = `${API_URL}/${FORGOT_PASSWORD}`
export const REQUEST_RESET_PASSWORD = `${API_URL}/${RESET_PASSWORD}`

// Server should return AuthModel
export function login(email: string, password: string) {
  return axios.post(LOGIN_URL, {email, password})
}

// Server should return AuthModel
export function register(email: string, firstname: string, lastname: string, password: string) {
  return axios.post<AuthModel>(REGISTER_URL, {
    email,
    firstname,
    lastname,
    password,
  })
}

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(email: string) {
  return axios.post<{status: number, message: string, error: string}>(REQUEST_PASSWORD_URL, {email})
}

export function resetPassword(email: string, password: string, password_confirmation: string, token: string) {
  return axios.post<{status: number, messag: string}>(REQUEST_RESET_PASSWORD, {email, password, password_confirmation, token})
}

export function getUserByToken(signal?: AbortSignal) {
  // Authorization head should be fulfilled in interceptor.
  // Check common redux folder => setupAxios
  return Get<UserInterface>({endpoint: GET_USER_BY_ACCESSTOKEN_URL, signal})
}
